export default __webpack_public_path__ + "static/media/notificationIcon.f4d8a1a9.svg";